import {inject, injectable} from 'inversify';

import {logger} from '../../../../utils/logger';
import {SendCromAnswersCommand} from '../ports/sendCromAnswers/SendCromAnswers.cmd';

@injectable()
export class SendCromAnswersUseCase {
  constructor(
    @inject(SendCromAnswersCommand)
    private readonly sendCromAnswersPort: SendCromAnswersCommand,
  ) {}

  async execute(dto: SendCromAnswersCommand.Params): Promise<void> {
    try {
      await this.sendCromAnswersPort.sendAnswers(dto);
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}
